import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

const IDLE = { status: "idle", data: null, loading: false };

// Sugere a Região de um bairro pelo nome (debounce 700 ms, mínimo 3 letras). `enabled=false` desliga.
export function useRegiaoSugestao(nome, { cidade, uf, enabled = true } = {}) {
  const [state, setState] = useState(IDLE);
  const seq = useRef(0);
  useEffect(() => {
    const n = (nome || "").trim();
    const id = ++seq.current;
    if (!enabled || n.length < 3) { setState(IDLE); return undefined; }
    setState((s) => ({ ...s, loading: true }));
    const t = setTimeout(async () => {
      try {
        const params = { nome: n };
        if (cidade) params.cidade = cidade;
        if (uf) params.uf = uf;
        const r = await api.get("/bairros/sugerir-regiao", { params });
        if (seq.current === id) setState({ status: r.data.status, data: r.data, loading: false });
      } catch {
        if (seq.current === id) setState({ status: "error", data: null, loading: false });
      }
    }, 700);
    return () => clearTimeout(t);
  }, [nome, cidade, uf, enabled]);
  return state;
}
